import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { getAccountInfo } from './salesforce';
import './Login.css';
import User from './User';
import { Toaster, toast } from 'react-hot-toast';

import logo from "./logo.png";

const Patient = () => {
 // Extract ID from URL
  const navigate = useNavigate();

  const [ id,setID ]=useState(null)

  const [initialData, setInitialData] = useState({});
  const [responseData, setResponseData] = useState({});
  const [errors, setErrors] = useState({});

 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setID(value);
  };

  const validateForm = () => {
    let isValid = true;
    let errors = {};

    // Simple validation checks
    if (!id) {
      isValid = false;
      errors.id = 'Patient id is required';
    }
   
    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {

      const response = await getAccountInfo(id);
      if(response){
        toast.success("Successfull");
        navigate(`/${id}`);

      }else{
      toast.error("Please Check Patient Id");
      }
      // Submit the form
    } else {
      console.log('Form is invalid');
    }
  };

  return (
    <div className='loginPage'>
        <Toaster/>
    <form onSubmit={handleSubmit} className="form-container">
    <div className='imageContainer'>
          <img src={logo} alt="Logo" />
        </div>
      <div className="form-group">
        <label className="label">Enter PatientId:</label>
        <input
          type="text"
          name="patientId"
          value={id}
          onChange={handleChange}
          className="input"
        />
        {errors.id && <p className="error-message">{errors.id}</p>}
      </div>
     
      <button type="submit" className="submit-button">Submit</button>
    </form>
    </div>
  );
  
};

export default Patient;